import { render, staticRenderFns } from "./new-briefing.vue?vue&type=template&id=6f901076&scoped=true&"
import script from "./new-briefing.js?vue&type=script&lang=js&"
export * from "./new-briefing.js?vue&type=script&lang=js&"
import style0 from "./new-briefing.vue?vue&type=style&index=0&id=6f901076&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f901076",
  null
  
)

export default component.exports